import NonLogin from '@/middleware/non-login.middleware';
import { ReactElement, useMemo } from 'react';
import { useRootSelector } from '@/hooks/selector.hook';
import Auth from './auth.middle';
import { Skeleton } from '@/components/ui/skeleton';

type MiddlewareProps = {
  children: ReactElement;
  fallback?: string;
  mode?: 'public' | 'private' | 'non-login';
};

export default function Middleware({ mode = 'public', children }: MiddlewareProps) {
  const { isAuthenticated, isLoading } = useRootSelector((state) => state.auth);

  const Gateway: any = useMemo(() => {
    if (mode === 'private') return Auth;
    if (mode === 'non-login') return NonLogin;
    return ({ children }: any) => children;
  }, [mode]);

  // Hiển thị loading khi đang check auth
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-main">
        <Skeleton className="h-[3.2rem] w-[3.2rem] rounded-full" />
      </div>
    );
  }

  return <Gateway logged={isAuthenticated}>{children}</Gateway>;
}
